export const sendExtensionMessage = (data: any) => {
  let evnt = new CustomEvent('chirpExt', { detail: data });
  window.dispatchEvent(evnt);
}